var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareTwitter = function SvgShareTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    viewBox: "0 0 21 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1DA1F2",
    fillRule: "nonzero",
    d: "M20.49 2.431c-.746.333-1.375.344-2.041.015.86-.515.9-.877 1.21-1.85a8.3 8.3 0 0 1-2.646 1.011 4.166 4.166 0 0 0-7.098 3.8A11.82 11.82 0 0 1 1.33 1.054 4.165 4.165 0 0 0 2.62 6.615a4.15 4.15 0 0 1-1.886-.52v.052a4.17 4.17 0 0 0 3.342 4.085 4.2 4.2 0 0 1-1.882.072 4.17 4.17 0 0 0 3.891 2.892 8.38 8.38 0 0 1-6.167 1.725 11.8 11.8 0 0 0 6.385 1.87c7.662 0 11.85-6.346 11.85-11.85q.001-.272-.01-.54c.813-.587 1.79-1.134 2.348-1.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1-2h22v22H-1z"
  }))));
};
export default SvgShareTwitter;